import {Platform} from 'react-native';

// For native apps, use the local network IP since localhost refers to the device itself
const getApiBaseUrl = () => {
  if (process.env.API_BASE_URL) {
    return process.env.API_BASE_URL;
  }
  // On native, use the deployed backend
  // On web, localhost works fine for development
  return Platform.OS === 'web'
    ? 'http://localhost:8080'
    : 'https://qnpzkdgh6n.eu-central-1.awsapprunner.com';
};

export const config = {
  // API base URL - configure based on environment
  apiBaseUrl: getApiBaseUrl(),

  // Sentry DSN for error reporting (SDK is disabled in dev via enabled: !__DEV__)
  sentryDsn: (process.env.SENTRY_DSN as string) || 'https://bfb95b2c2466c6f0113b13b6e71e6944@o4510965626372096.ingest.de.sentry.io/4510965628141648',

  // Default photo cycle interval in milliseconds
  defaultPhotoCycleIntervalMs: 30000,

  // Session token storage key
  sessionTokenKey: 'oma_session_token',

  // Maximum reminders to display
  maxRemindersDisplay: 4,
} as const;
